import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { getValidIdToken } from "../firebase/firebase-handler";
import "./ModalPurchase.css";

let openPayPalFn = null;

/**
 * Called from Unity
 * config = { packId }
 */
export function openPayPalPurchaseModal(json) {
  const config = JSON.parse(json)
  console.log('[openPayPalPurchaseModal] hit this with config:', config);
  openPayPalFn && openPayPalFn(config);
}

export const ModalPurchasePayPal = () => {
  const [visible, setVisible] = useState(false);
  const [packId, setPackId] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    openPayPalFn = (config) => {
      setPackId(config?.item?.id);
      setVisible(true);
    };
    return () => (openPayPalFn = null);
  }, []);

  if (!visible || !packId) return null;

  const startPayPalCheckout = async () => {
    try {
      setLoading(true);
      const token = await getValidIdToken();

      const res = await fetch(
        "https://api.tipsynites.app/payments/paypal/create-order",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ packId })
        }
      );

      const { approveUrl } = await res.json();
      window.location.href = approveUrl;
    } catch (err) {
      console.error("[PayPal] Checkout failed", err);
      alert("Unable to start PayPal checkout.");
      setLoading(false);
    }
  };

  return ReactDOM.createPortal(
    <div className="purchase-overlay" onClick={() => setVisible(false)}>
      <div
        className="purchase-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <h3>Confirm Purchase</h3>

        <button
          className="purchase-button paypal"
          disabled={loading}
          onClick={startPayPalCheckout}
        >
          {loading ? "Redirecting…" : "Pay with PayPal"}
        </button>

        <button className="cancel" onClick={() => setVisible(false)}>
          Cancel
        </button>
      </div>
    </div>,
    document.body
  );
};
